/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Handle hash navigation on route changes
export const onRouteUpdate = ({ location }) => {
  if (location.hash) {
    setTimeout(() => {
      const id = location.hash.substring(1);
      const element = document.getElementById(id);
      if (element) {
        const headerOffset = 100;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
        element.focus();
      }
    }, 100);
  }
};
